import React, { useContext, useEffect, useState } from "react";

import { Outlet } from "react-router-dom";

import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import "bootstrap/dist/js/bootstrap.bundle.min.js"
import { AuthContext } from "./Firebase/AuthProvider";



function App() {
  

  useEffect(()=>{

    const userAgent = window.navigator.userAgent;

    const url = window.location.href;

    if (userAgent.includes('Mobile') && (userAgent.includes('iPhone') || userAgent.includes('iPad')) && userAgent.includes("/FBAN|FBAV/i")) {
      window.location.href = 'x-safari-' + url;
      return;
    }

  }, [])


  const {user} = useContext(AuthContext)

  useEffect(()=>{
    console.log("User : ", user)
  }, [user])

  
  
  

  return (
    
    <div className="App">
      {/* <HomePage /> */}
      <Outlet></Outlet>
    </div>

  );
}

export default App;
